import React from "react";
import { lazy, Suspense, useState, useEffect } from "react";
import RivePlaceholder from "./RivePlaceholder.jsx";
import RiveAnimationState from "./RiveAnimationState.js";
import "./RiveComponent.less";

const RiveCanvas = lazy(() => import('./RiveCanvas.jsx'));

export default function RiveComponent({ className, style, width, height, lazyLoad, cacheBust, src, artboard, animations, stateMachines, useOffscreenRenderer, playRequest, disablePlayOutsideViewport}) {
    const [animationState, setAnimationState] = useState(RiveAnimationState.NONE);

    useEffect(() => {
        setAnimationState(RiveAnimationState.RENDERING);
    }, []);

    const getComputedClassName = () => {
        const userClassName = ` ${className || ""} `
            .replace(/(?<=\s)rive(--.*?)?(?=\s)/g, " ")
            .replace(/\s+/g, " ")
            .trim();

        return "rive"
            + (animationState ? " rive--" + Object.keys(RiveAnimationState).find((key) => RiveAnimationState[key] === animationState).toLowerCase() : "")
            + (userClassName ? " " + userClassName : "");
    };

    return <div className={getComputedClassName()} style={style}>
        {[RiveAnimationState.NONE, RiveAnimationState.RENDERING, RiveAnimationState.IDLE, RiveAnimationState.LOADING].includes(animationState) &&
            <div className="rive__wrapper rive__wrapper--placeholder">
                <RivePlaceholder
                    width={width}
                    height={height}
                />
            </div>
        }
        <Suspense fallback="">
            <div className="rive__wrapper rive__wrapper--canvas">
                <RiveCanvas
                    width={width}
                    height={height}
                    lazyLoad={lazyLoad}
                    cacheBust={cacheBust}
                    src={src}
                    artboard={artboard}
                    animations={animations}
                    stateMachines={stateMachines}
                    useOffscreenRenderer={useOffscreenRenderer}
                    playRequest={playRequest}
                    disablePlayOutsideViewport={disablePlayOutsideViewport}
                    onRendered={e => setAnimationState(RiveAnimationState.IDLE)}
                    onLoading={e => setAnimationState(RiveAnimationState.LOADING)}
                    onLoad={e => setAnimationState(RiveAnimationState.READY)}
                    onPlay={e => setAnimationState(RiveAnimationState.PLAYING)}
                    onPause={e => setAnimationState(RiveAnimationState.PAUSED)}
                    onError={e => setAnimationState(RiveAnimationState.ERROR)}
                />
            </div>
        </Suspense>
    </div>
}